import * as actionType from './action-type'

export const setLoginAccount = user => ({
  type: actionType.SET_LOGIN_ACCOUNT,
  payload: { user }
})
